import React from 'react';
import { BatchesSubmittedContainer } from '../../../containers';

export const BatchesSubmitted = () => <BatchesSubmittedContainer />;
